import { LogOut } from 'lucide-react'
import { useAuth } from '../../context/AuthContext'
import { WolfMark } from '../brand/WolfMark'

export function MobileHeader() {
  const { logout } = useAuth()

  return (
    <header className="mobile-header">
      <div className="mobile-brand">
        <WolfMark className="mobile-wolf" title="Wolf Forge" />
        <strong>WILLIAM'S TREASURE</strong>
      </div>
      <div className="mobile-header-actions">
        <button className="icon-button mobile-logout" onClick={logout} type="button" aria-label="Sign out">
          <LogOut size={18} />
        </button>
      </div>
    </header>
  )
}
